import * as yup from 'yup';

const validators = (__) => () => {
    return yup.object().shape({

        COD_FACTURA: yup.string().required(__(`form.COD_FACTURA.error`)),
        price: yup.number().required(__(`form.price.error`)),

        division: yup.number().when('COD_FACTURA', (COD_FACTURA, schema) => {
            if (COD_FACTURA[0] === 'TR0001' || COD_FACTURA[0] === 'TR0002' ) return schema.required(__(`form.division.error`))
        }),

        municipioStart: yup.number().when('COD_FACTURA', (COD_FACTURA, schema) => {
            if (COD_FACTURA[0] === 'TR0001' || COD_FACTURA[0] === 'TR0002') return schema.required(__(`form.municipioStart.error`))
        }),

        municipioEnd: yup.number().when('COD_FACTURA', (COD_FACTURA, schema) => {
            if (COD_FACTURA[0] === 'TR0001' || COD_FACTURA[0] === 'TR0002' ) return schema.required(__(`form.municipioEnd.error`))
        }),

        IdTransportType: yup.number().when('COD_FACTURA', (COD_FACTURA, schema) => {
            if (COD_FACTURA[0] === 'TR0001' || COD_FACTURA[0] === 'TR0002') return schema.required(__(`form.IdTransportType.error`))
        }),

    });
};

export  default  validators ;
